@if (request(); as r) {
  <div (click)="cancel()" class="backdrop">
    <div (click)="stopProp($event)" class="dialog">

      <div class="body">
        <!-- Ikona -->
        <div class="icon" [class.danger]="r.danger">
          @if (r.danger) {
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#DC2626" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
          } @else {
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="var(--acc)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></svg>
          }
        </div>

        <h2 class="title">{{ r.title }}</h2>
        @if (r.message) {
          <p class="message">{{ r.message }}</p>
        }
      </div>

      <div class="actions">
        <button (click)="cancel()" class="btn-cancel">{{ r.cancelText ?? 'Anuluj' }}</button>
        <button (click)="ok()" class="btn-ok" [class.danger]="r.danger">{{ r.confirmText ?? 'Potwierdź' }}</button>
      </div>

    </div>
  </div>
}
